import React, { useState } from 'react';
import axios from '../api/api';
import Layout from '../components/Layout';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/users/forgot-password', { email });
            setMessage(response.data.message);
            setError('');
        } catch (err) {
            setError('Không thể gửi email đặt lại mật khẩu. Vui lòng kiểm tra lại email.');
            setMessage('');
        }
    };

    return (
        <Layout>
            <div className="container mt-5"     style={{ backgroundColor: 'white', minHeight: '100vh', padding: '20px' }}>
                <h2>Quên Mật Khẩu</h2>
                <form onSubmit={handleForgotPassword}>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email</label>
                        <input
                            type="email"
                            id="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    {message && <p className="text-success">{message}</p>}
                    {error && <p className="text-danger">{error}</p>}
                    <button type="submit" className="btn btn-primary">Gửi Email Đặt Lại Mật Khẩu</button>
                </form>
            </div>
        </Layout>
    );
};

export default ForgotPassword;
